var API_DOMAIN = "https://crackersprice.com/api";

export default API_DOMAIN;
